module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--de-b25e7b61f1436ee1533703d3568fd9c2.webp";